import script from "./CompanyAnnualReport.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyAnnualReport.vue?vue&type=script&setup=true&lang=js"

import "./CompanyAnnualReport.vue?vue&type=style&index=0&id=79b8a730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b8a730"]])

export default __exports__